// @flow

import React from 'react';
import ToggleAction from './toggleAction.styled';

type Props = {
  onClick: Function,
  label: string,
  open: boolean,
};

export default ({ onClick, label, open }: Props) => (
  <ToggleAction
    onClick={onClick}
    open={open}
  >
    {label}
  </ToggleAction>
);
